import { render, staticRenderFns } from "./ContactComponent.vue?vue&type=template&id=53aef8f6&"
import script from "./ContactComponent.vue?vue&type=script&lang=js&"
export * from "./ContactComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtnGroup,QSeparator} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtnGroup,QSeparator})
